<div
  class="productSnippet"
  [ngClass]="{'productSnippet--arrangement': isArrangement}"
  [class.sold]="product.sold"
  [attr.itemprop]="this.hasSeo('similarProducts') ? 'Product' : null"
  [attr.itemscope]="this.hasSeo('similarProducts') ? '' : null"
  [attr.itemtype]="this.hasSeo('similarProducts') ? 'https://schema.org/Product' : null"
>
  <div class="productSnippet__top">
    <div
      class="productSnippet__sellerBadge vc-badge vc-badge--large vc-badge--sm-down vc-badge--expert"
      *ngIf="expertSellerBadge && !isArrangement"
    >
      <vc-sprite-icons class="icon" name="badge-expert"></vc-sprite-icons>
      <span i18n="@@PRODUCT_SNIPPET.EXPERT_SELLER">
        expert seller
      </span>
    </div>

    <div
      class="productSnippet__sellerBadge vc-badge vc-badge--large vc-badge--sm-down vc-badge--trusted"
      *ngIf="trustedSellerBadge"
    >
      <vc-sprite-icons name="badge-trusted" class="icon"></vc-sprite-icons>
      <span i18n="@@PRODUCT_SNIPPET.TRUSTED_SELLER">
        trusted seller
      </span>
    </div>

    <div
      class="productSnippet__sellerBadge vc-badge vc-badge--large vc-badge--sm-down vc-badge--official-store"
      *ngIf="isOfficialStoreBadge"
    >
      <span i18n="@@PRODUCT.DESCRIPTION.BRAND_STORE">
        Brand Approved
      </span>
    </div>

    <vc-like
      class="productSnippet__like"
      className="productSnippet__like"
      [isLiked]="isLiked"
      [likeCount]="product.likeCount"
      [isOldDesign]="true"
      type="products"
      [idItem]="product.id"
      (likeSuccess)="likeSuccess($event)"
    ></vc-like>
  </div>
  <vc-ref resource="{{ product.path }}" [anchor]="!product.shouldBeGone" microData="url" (click)="clickProduct($event)">
    <meta itemprop="sku" [content]="product.id" />
    <div class="productSnippet__imageWrapper">
      <vc-images
        class="productSnippet__imageWrapper__image"
        [eventToObserve]="eventToObserve"
        [lazyOff]="lazyOff && index < MinImageLazyLoaded"
        [width]="224"
        [height]="224"
        url="{{ this.imgSEOPath }}"
        alt="{{ product.pictures[0].alt || product.name + ' ' + product.brand?.name }}"
      ></vc-images>
      <span *ngIf="product.sold" class=" productSnippet__imageWrapper__soldText " i18n="@@PRODUCT_SNIPPET.SOLD"
        >Already sold</span
      >
    </div>
  </vc-ref>

  <div class="productSnippet__tags">
    <ng-container *ngIf="isDealActive; else regularTags">
      <span
        class="productSnippet__tags__item"
        [ngStyle]="{color: currentDeal?.textColor, 'background-color': currentDeal?.backgroundColor}"
        >{{ currentDeal?.localizedName }}</span
      >
    </ng-container>
    <ng-template #regularTags>
      <span *ngFor="let tag of product.tags" class="productSnippet__tags__item">{{ tag }}</span>
    </ng-template>
  </div>

  <div class="productSnippet__infos">
    <vc-ref
      resource="{{ product.path }}"
      [anchor]="!product.shouldBeGone"
      microData="url"
      (click)="clickProduct($event)"
    >
      <h2>
        <span class="productSnippet__text--brand" *ngIf="product?.brand.name" itemprop="brand"
          >{{ product?.brand.name }}
        </span>
        <span class="productSnippet__text--name" itemprop="name">{{ product?.name }}</span>

        <p *ngIf="product?.size && product?.size?.size" class="productSnippet__size" itemprop="description">
          <span i18n="@@PRODUCT.DESCRIPTION.DETAILS.SIZE">Size:</span>
          <span>{{ product.size.size }}{{ product.size.localizedStandard }}</span>
        </p>
      </h2>
    </vc-ref>
    <ng-container *ngIf="!isServer"> <ng-container *ngTemplateOutlet="priceContainer"></ng-container> </ng-container>
  </div>
  <!-- DIRECT SHIPPING / EXPRESS DELIVERY -->
  <ng-container *ngIf="isServer"> <ng-container *ngTemplateOutlet="priceContainer"></ng-container> </ng-container>
  <div *ngIf="!isArrangement" class="productSnippet__bottom">
    <div *ngIf="!product.sold && isDirectShipping" class="productSnippet__ds">
      <vc-sprite-icons name="handshake" class="productSnippet__ds__icon"></vc-sprite-icons>
      <span class="productSnippet__ds__label vc-text-s" i18n="@@PRODUCT_SNIPPET.DIRECT_SHIPPING">Direct Shipping</span>
    </div>

    <div *ngIf="product.inStock && !product.sold" class="productSnippet__express">
      <vc-sprite-icons class="productSnippet__express__icon" name="express"></vc-sprite-icons>
      <span class="productSnippet__express__label vc-text-s" i18n="@@DELIVERY_OPTS.EXPRESS">Express Delivery</span>
    </div>
  </div>

  <!-- LOCATION -->
  <div *ngIf="isLocationEnable && !isArrangement" class="productSnippet__location">
    <ng-container *ngIf="isLocalCountry; else pinIcon">
      <vc-sprite-icons
        class="productSnippet__location__icon productSnippet__location__icon--leaf"
        name="sustainable-leaf"
      ></vc-sprite-icons>
    </ng-container>
    <ng-template #pinIcon>
      <vc-sprite-icons class="productSnippet__location__icon" name="pin-full"> </vc-sprite-icons
    ></ng-template>
    <span class="productSnippet__location__country vc-text-s">{{
      (i18nData.getCountryFromIso(product?.isoCountry) | async)?.name
    }}</span>
  </div>
</div>

<ng-template #priceContainer>
  <span
    class="productSnippet__price"
    [ngClass]="{'productSnippet__price--discount': product?.regularPrice?.formatted}"
    itemprop="offers"
    itemscope
    itemtype="https://schema.org/Offer"
  >
    <span class="productSnippet__regularPrice " *ngIf="product?.regularPrice?.formatted">{{
      product?.regularPrice?.formatted
    }}</span>
    {{ product.price.formatted }}
    <span
      *ngIf="product?.price?.currency"
      [hidden]="true"
      itemprop="priceCurrency"
      [attr.content]="product?.price?.currency"
    >
      <ng-container [ngSwitch]="product.price.currency">
        <ng-container *ngSwitchCase="'USD'">$</ng-container>
        <ng-container *ngSwitchCase="'GBP'">£</ng-container>
        <ng-container *ngSwitchCase="'HKD'">HK$</ng-container>
        <ng-container *ngSwitchCase="'SGD'">S$</ng-container>
        <ng-container *ngSwitchCase="'AUD'">$A</ng-container>
        <ng-container *ngSwitchCase="'CAD'">CA$</ng-container>
        <ng-container *ngSwitchCase="'PLN'">zł</ng-container>
        <ng-container *ngSwitchCase="'CHF'">CHF</ng-container>
        <ng-container *ngSwitchCase="'SEK'">SEK</ng-container>
        <ng-container *ngSwitchCase="'DKK'">DKK</ng-container>
        <ng-container *ngSwitchCase="'YEN'">¥</ng-container>
        <ng-container *ngSwitchCase="'CNY'">RMB</ng-container>
        <ng-container *ngSwitchDefault>€</ng-container>
      </ng-container>
    </span>
    <span *ngIf="product?.price?.cents && product?.price?.currency" [hidden]="true" itemprop="price">{{
      product.price.cents / 100
    }}</span>
    <link *ngIf="!product.sold" itemprop="availability" href="https://schema.org/InStock" />
    <link *ngIf="product.sold" itemprop="availability" href="https://schema.org/SoldOut" />
    <meta itemprop="url" [attr.content]="product.path" />
    <link itemprop="itemCondition" href="https://schema.org/UsedCondition" />
  </span>
  <ng-template #price class="productSnippet__price">{{ product.price.formatted }}</ng-template>
</ng-template>
